"use client"

import { t } from "@/languages/i18n"
import { PlusOutlined } from "@ant-design/icons"
import { Button, Image, Modal } from "antd"
import React, { useState } from "react"
import { Images } from "../../../../constants/images"
import { MediaData } from "../../../../lib/config/types"
import { toImageSrc } from "../../../../lib/utils"
import Media from "../../media/pages/Media"

interface FeaturedImageProps {
  selectedMedia: MediaData | null
  setSelectedMedia: (media: MediaData | null) => void
}

/**
 * Featured image picker — redesigned: no own card / title / collapse.
 * Parent FormSection groups it.
 */
const FeaturedImage: React.FC<FeaturedImageProps> = ({ selectedMedia, setSelectedMedia }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleOpenModal = () => setIsModalOpen(true)
  const handleCloseModal = () => setIsModalOpen(false)
  const handleSelectMedia = (media: MediaData) => {
    setSelectedMedia(media)
    setIsModalOpen(false)
  }

  return (
    <div>
      {!selectedMedia ? (
        <div className="flex flex-col gap-3">
          <button
            type="button"
            onClick={handleOpenModal}
            aria-label={t("Chọn ảnh đại diện")}
            style={{
              width: "100%",
              aspectRatio: "16/9",
              border: "1px dashed var(--admin-border)",
              borderRadius: 8,
              background: "var(--admin-muted)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
            }}
          >
            <Image src={Images.imgEmpty.src} alt="" preview={false} height={56} width={56} />
          </button>
          <Button icon={<PlusOutlined />} onClick={handleOpenModal}>
            {t("Chọn ảnh đại diện")}
          </Button>
        </div>
      ) : (
        <div className="flex flex-col gap-2">
          <Image
            src={toImageSrc(!selectedMedia?.attributes ? selectedMedia?.url : selectedMedia?.attributes?.url)}
            alt={t("Ảnh đại diện")}
            className="w-full"
            style={{ borderRadius: 8, border: "1px solid var(--admin-border)" }}
          />
          <div className="flex gap-2">
            <Button size="small" onClick={handleOpenModal} className="flex-1">
              {t("Đổi ảnh")}
            </Button>
            <Button size="small" danger onClick={() => setSelectedMedia(null)} className="flex-1">
              {t("Gỡ ảnh")}
            </Button>
          </div>
        </div>
      )}
      <Modal
        open={isModalOpen}
        title={t("Chọn media")}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <Media isOpenModal={true} onSelectMedia={media => handleSelectMedia(media as MediaData)} />
      </Modal>
    </div>
  )
}

export default FeaturedImage
